'use client';

import React, { useContext } from 'react';
import clsx from 'clsx';

import ThemeContext from '@/context/theme';

type Props = {
  children: React.ReactNode;
};

/**
 * Client component which alters child ones and injects Internship App theme class. To be used with
 * `styles/theme.scss` mixins and apply light/dark theme component styles (see `Layout.tsx` for reference).
 */
const ThemeInjector: React.FC<Props> = ({ children }) => {
  const { theme } = useContext(ThemeContext);

  return React.Children.map(children, (child) => {
    if (React.isValidElement<any>(child)) {
      return React.cloneElement(child, {
        className: clsx(child.props.className, `ia-theme-${theme}`),
      });
    }
    return child;
  });
};

export default ThemeInjector;
